'use client';

import { useEffect } from 'react';
import { usePathname, useSearchParams } from 'next/navigation';
import NProgress from 'nprogress';
import { Url } from 'next/dist/shared/lib/router/router';

NProgress.configure({
	showSpinner: false,
});

export function onStart(nextRoute: string | Url, currentRoute: string) {
	if (nextRoute.toString() === currentRoute) return false;

	NProgress.start();
}

/**
 * Router events
 * https://nextjs.org/docs/app/building-your-application/routing/linking-and-navigating#router-events
 */
export function NavigationEvents() {
	const pathname = usePathname();
	const searchParams = useSearchParams();

	useEffect(() => {
		NProgress.done();
	}, [pathname, searchParams]);

	return null;
}
